import { CalendarClock, ExternalLink } from "lucide-react";
import { toast } from "sonner";

/**
 * Bouton "Créer une tâche" — ouvre la fiche Sellsy du devis créé
 * (ou de l'opportunité si pas de devis), depuis laquelle l'utilisateur
 * peut ajouter une activité avec l'objet lié déjà rempli.
 */
const CreateTaskButton = ({ createdQuote, createdOpportunity }) => {
  const buildSellsyUrl = () => {
    if (createdQuote?.sellsy_url) return createdQuote.sellsy_url;
    if (createdQuote?.sellsy_id) {
      return `https://www.sellsy.com/?_f=estimateOverview&id=${createdQuote.sellsy_id}`;
    }
    if (createdOpportunity?.sellsy_id) {
      return `https://www.sellsy.com/prospection/opportunities/${createdOpportunity.sellsy_id}`;
    }
    return null;
  };

  const url = buildSellsyUrl();
  const isDisabled = !url;
  const linkedLabel = createdQuote
    ? `Devis #${createdQuote.sellsy_id || "local"}`
    : createdOpportunity
    ? `Opportunité #${createdOpportunity.sellsy_id || "local"}`
    : null;

  const handleClick = () => {
    if (isDisabled) {
      toast.info("Créez d'abord un devis ou une opportunité.");
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
    toast.success(
      `Fiche Sellsy ouverte. Cliquez sur « + Activité » pour créer une tâche liée à ${linkedLabel}.`
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      className={`card w-full flex items-center gap-3 text-left transition-colors ${
        isDisabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-slate-50 cursor-pointer"
      }`}
      data-testid="action-create-task-btn"
    >
      <div className="w-8 h-8 rounded-md flex items-center justify-center bg-slate-100 text-slate-600 flex-shrink-0">
        <CalendarClock className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-slate-900">Créer une tâche</p>
        <p className="text-xs text-slate-500 truncate">
          {linkedLabel
            ? `Ouvre Sellsy — Objet lié : ${linkedLabel}`
            : "Créez d'abord un devis ou une opportunité"}
        </p>
      </div>
      {!isDisabled && <ExternalLink className="w-4 h-4 text-slate-400 flex-shrink-0" />}
    </button>
  );
};

export default CreateTaskButton;
